module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 for (var i=0; i < data.cells.length; i++) { ;
__p += '\n';
 var className = typeof data.cells[i].className === "string" ? data.cells[i].className : "dynamic"; ;
__p += '\n';
 var modelAttribute = typeof data.cells[i].modelAttribute === "string" ? data.cells[i].modelAttribute : "dynamic"; ;
__p += '\n<td class="table-cell ' +
((__t = ( className )) == null ? '' : __t) +
'" data-attribute="' +
((__t = ( modelAttribute )) == null ? '' : __t) +
'" data-csvtext="' +
((__t = ( data.cells[i].csvtext )) == null ? '' : __t) +
'">' +
((__t = ( data.cells[i].content )) == null ? '' : __t) +
'</td>\n';
 } ;
__p += '\n';
return __p
}